export default Object.freeze({
  Pending: 1,
  Approved: 2,
  Rejected: 3,
});
